import * as iconsApi from '../api/icons'
import { handleApiError } from './api-errors'
import { showSuccess } from './alerts'

export const GET_ICON_LIST = 'GET_ICON_LIST'

export const getAvailableIconList = () => (dispatch) => {
    iconsApi
        .listObj()
        .then((res) => {
            dispatch({
                type: GET_ICON_LIST,
                payload: res,
            })
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const addIconToAvailable = (iconName) => (dispatch) => {
    iconsApi
        .putObj({ name: iconName })
        .then(() => {
            dispatch(getAvailableIconList())
            dispatch(showSuccess('Icon added.'))
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const removeIconFromAvailable = (icon_id) => (dispatch) => {
    iconsApi
        .deleteObj(icon_id)
        .then(() => {
            dispatch(getAvailableIconList())
            dispatch(showSuccess('Icon removed.'))
        })
        .catch((err) => dispatch(handleApiError(err)))
}
